var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jasBoardEntityName } from '../../../../backend/config/shared';
import { getBooleanStringValue } from '../../../../backend/utils';
import { useCredentialingTranslation } from '../../../../ui/hooks';
import { ClassifierAdminPage, SlideoutFields } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { capitalize } from '@mui/material';
import React from 'react';
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    const { t } = useCredentialingTranslation();
    return (React.createElement(SlideoutFields, { fields: [
            { label: t('common.status'), value: capitalize(props.response.data.status) },
            {
                label: t('adminPages.jasBoard.escapeNonNumericCharacters'),
                value: capitalize(getBooleanStringValue(!!props.response.data.escapeNonNumericCharacters)),
            },
            {
                label: t('adminPages.jasBoard.escapeLeadingZeros'),
                value: capitalize(getBooleanStringValue(!!props.response.data.escapeLeadingZeros)),
            },
        ] }));
};
const formConfig = {
    key: '!form',
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Name',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
        {
            type: 'form.text',
            key: 'fieldClient',
            label: 'Client Field',
            emptyAsNull: true,
        },
        {
            type: 'form.number',
            key: 'verificationInterval',
            label: 'Verification Interval in minutes',
            integer: true,
        },
        {
            type: 'form.number',
            key: 'outOfDateAfter',
            label: 'Out of Date after days',
            integer: true,
        },
        createFieldWidget('fieldDisciplineId', 'Discipline Id Field'),
        createFieldWidget('fieldMiddleName', 'Middle Name Field'),
        createFieldWidget('fieldDateOfBirth', 'Date Of Birth Field'),
        createFieldWidget('fieldYearOfBirth', 'Year Of Birth Field'),
        createFieldWidget('fieldSsnLast4Digits', 'Last 4 SSN Digits Field'),
        createFieldWidget('fieldCounty', 'County Field'),
        {
            type: 'form.dataGrid',
            key: 'additionalFields',
            description: 'Not supported/needed for now. The Field radio button above should cover all cases for JAS boards',
            emptyAsNull: true,
            addButtonLabel: 'Add Field',
            label: 'Additional Fields',
            children: [
                {
                    type: 'form.text',
                    label: 'Field',
                    validate: {
                        required: true,
                    },
                },
            ],
        },
        {
            type: 'form.checkbox',
            key: 'escapeNonNumericCharacters',
            label: 'Escape Non-Numeric Characters',
            defaultValue: false,
        },
        {
            type: 'form.checkbox',
            key: 'escapeLeadingZeros',
            label: 'Escape Leading Zeros',
            defaultValue: false,
        },
        {
            type: 'form.checkbox',
            key: 'testEnabled',
            label: 'Enable Test Mode',
            defaultValue: false,
        },
        {
            type: 'form.panel',
            children: [
                {
                    type: 'form.text',
                    key: 'testResponse',
                    label: 'Response From JAS',
                    multiline: true,
                    rows: 10,
                    validate: {
                        required: true,
                        custom: (value) => {
                            if (value) {
                                try {
                                    JSON.parse(value);
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                }
                                catch (e) {
                                    return e.message;
                                }
                            }
                        },
                    },
                    style: {
                        monospace: true,
                    },
                },
                {
                    type: 'form.panel',
                    label: 'Example Responses',
                    children: [
                        {
                            type: 'form.button',
                            label: 'Active',
                            event: {
                                onClick: (handler) => {
                                    var _a;
                                    (_a = handler
                                        .up()
                                        .up()
                                        .down('testResponse')) === null || _a === void 0 ? void 0 : _a.setData(JSON.stringify(exampleResponseActive, undefined, '  '));
                                },
                            },
                            style: {
                                width: 300,
                            },
                            hidden: {
                                custom: (handler) => {
                                    return handler.formData.name.toLowerCase() === 'oig';
                                },
                            },
                        },
                        {
                            type: 'form.button',
                            label: 'Inactive',
                            event: {
                                onClick: (handler) => {
                                    var _a;
                                    (_a = handler
                                        .up()
                                        .up()
                                        .down('testResponse')) === null || _a === void 0 ? void 0 : _a.setData(JSON.stringify(exampleResponseInactive, undefined, '  '));
                                },
                            },
                            style: {
                                width: 300,
                            },
                            hidden: {
                                custom: (handler) => {
                                    return handler.formData.name.toLowerCase() === 'oig';
                                },
                            },
                        },
                        {
                            type: 'form.button',
                            label: 'Expired',
                            event: {
                                onClick: (handler) => {
                                    var _a;
                                    (_a = handler
                                        .up()
                                        .up()
                                        .down('testResponse')) === null || _a === void 0 ? void 0 : _a.setData(JSON.stringify(exampleResponseExpired, undefined, '  '));
                                },
                            },
                            style: {
                                width: 300,
                            },
                            hidden: {
                                custom: (handler) => {
                                    return handler.formData.name.toLowerCase() === 'oig';
                                },
                            },
                        },
                        {
                            type: 'form.button',
                            label: 'Match',
                            event: {
                                onClick: (handler) => {
                                    var _a;
                                    (_a = handler
                                        .up()
                                        .up()
                                        .down('testResponse')) === null || _a === void 0 ? void 0 : _a.setData(JSON.stringify(exampleOigMatchResponse, undefined, '  '));
                                },
                            },
                            style: {
                                width: 300,
                            },
                            hidden: {
                                custom: (handler) => {
                                    return handler.formData.name.toLowerCase() !== 'oig';
                                },
                            },
                        },
                        {
                            type: 'form.button',
                            label: 'No Match',
                            event: {
                                onClick: (handler) => {
                                    var _a;
                                    (_a = handler
                                        .up()
                                        .up()
                                        .down('testResponse')) === null || _a === void 0 ? void 0 : _a.setData(JSON.stringify(exampleOigNoMatchResponse, undefined, '  '));
                                },
                            },
                            style: {
                                width: 300,
                            },
                            hidden: {
                                custom: (handler) => {
                                    return handler.formData.name.toLowerCase() !== 'oig';
                                },
                            },
                        },
                    ],
                    style: {
                        layout: 'row',
                        horizontalAlign: 'center',
                    },
                },
            ],
            hidden: {
                when: '^testEnabled',
                dataNotEq: true,
            },
        },
    ],
};
function createFieldWidget(key, label) {
    return {
        type: 'form.radio',
        key,
        label,
        values: [
            { value: undefined, label: 'Not Used' },
            { value: 'optional', label: 'Optional' },
            ...(key !== 'fieldMiddleName' ? [{ value: 'required', label: 'Required' }] : []),
        ],
        style: {
            inline: true,
        },
    };
}
const csvFileHeader = [
    'ID',
    'Name',
    'Status',
    'Client Field',
    'Discipline Id Field',
    'Middle Name Field',
    'Date Of Birth Field',
    'Year Of Birth Field',
    'Last 4 SSN Digits Field',
    'County Field',
    'Verification Interval',
    'Out of Date after',
    'Additional Fields',
    'Test Enabled',
    'Test Response',
    'Escape Non-Numeric Characters',
    'Escape Leading Zeros',
];
function mapCsvRowToData(row) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    let i = -1;
    const id = ((_a = row.data[++i]) !== null && _a !== void 0 ? _a : '').trim();
    const name = ((_b = row.data[++i]) !== null && _b !== void 0 ? _b : '').trim();
    const status = ((_c = row.data[++i]) !== null && _c !== void 0 ? _c : '').trim().toLowerCase();
    const fieldClient = ((_d = row.data[++i]) !== null && _d !== void 0 ? _d : '').trim();
    const fieldDisciplineId = ((_e = row.data[++i]) !== null && _e !== void 0 ? _e : '').trim();
    const fieldMiddleName = ((_f = row.data[++i]) !== null && _f !== void 0 ? _f : '').trim();
    const fieldDateOfBirth = ((_g = row.data[++i]) !== null && _g !== void 0 ? _g : '').trim();
    const fieldYearOfBirth = ((_h = row.data[++i]) !== null && _h !== void 0 ? _h : '').trim();
    const fieldSsnLast4Digits = ((_j = row.data[++i]) !== null && _j !== void 0 ? _j : '').trim();
    const fieldCounty = ((_k = row.data[++i]) !== null && _k !== void 0 ? _k : '').trim();
    const verificationInterval = parseInt(((_l = row.data[++i]) !== null && _l !== void 0 ? _l : '').trim());
    const outOfDateAfter = parseInt(((_m = row.data[++i]) !== null && _m !== void 0 ? _m : '').trim());
    let additionalFields = ((_o = row.data[++i]) !== null && _o !== void 0 ? _o : '').trim().split(';').filter(Boolean);
    const escapeNonNumericCharacters = ((_p = row.data[++i]) !== null && _p !== void 0 ? _p : '').trim().toLowerCase() === 'yes';
    const escapeLeadingZeros = ((_q = row.data[++i]) !== null && _q !== void 0 ? _q : '').trim().toLowerCase() === 'yes';
    const testEnabled = ((_r = row.data[++i]) !== null && _r !== void 0 ? _r : '').trim().toLowerCase() === 'yes';
    let testResponse = ((_s = row.data[++i]) !== null && _s !== void 0 ? _s : '').trim();
    if (name.length === 0) {
        row.errors.push('Name is required');
    }
    if (status.length === 0) {
        row.errors.push('Status is required');
    }
    switch (status) {
        case 'active':
        case 'deprecated':
        case 'retired':
            break;
        default:
            row.errors.push('Invalid status, expected one of: active, deprecated, retired');
    }
    if (additionalFields.length === 0) {
        additionalFields = undefined;
    }
    if (!testResponse) {
        testResponse = undefined;
    }
    const mapField = (field) => {
        const f = field.toLowerCase();
        if (f === 'required') {
            return 'required';
        }
        else if (f === 'optional') {
            return 'optional';
        }
        else {
            return undefined;
        }
    };
    if (row.errors.length === 0) {
        row.object = {
            id: id,
            data: {
                name,
                status: status,
                fieldClient,
                fieldDisciplineId: mapField(fieldDisciplineId),
                fieldMiddleName: mapField(fieldMiddleName),
                fieldDateOfBirth: mapField(fieldDateOfBirth),
                fieldYearOfBirth: mapField(fieldYearOfBirth),
                fieldSsnLast4Digits: mapField(fieldSsnLast4Digits),
                fieldCounty: mapField(fieldCounty),
                additionalFields,
                escapeNonNumericCharacters,
                escapeLeadingZeros,
                testEnabled,
                testResponse,
                verificationInterval,
                outOfDateAfter,
            },
        };
    }
    return Promise.resolve(row);
}
function mapDataToCsvRow(response) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const data = response.data;
        return [
            response.id,
            data.name,
            data.status,
            (_a = data.fieldClient) !== null && _a !== void 0 ? _a : '',
            (_b = data.fieldDisciplineId) !== null && _b !== void 0 ? _b : '',
            (_c = data.fieldMiddleName) !== null && _c !== void 0 ? _c : '',
            (_d = data.fieldDateOfBirth) !== null && _d !== void 0 ? _d : '',
            (_e = data.fieldYearOfBirth) !== null && _e !== void 0 ? _e : '',
            (_f = data.fieldSsnLast4Digits) !== null && _f !== void 0 ? _f : '',
            (_g = data.fieldCounty) !== null && _g !== void 0 ? _g : '',
            (_j = (_h = data.verificationInterval) === null || _h === void 0 ? void 0 : _h.toString()) !== null && _j !== void 0 ? _j : '',
            (_l = (_k = data.outOfDateAfter) === null || _k === void 0 ? void 0 : _k.toString()) !== null && _l !== void 0 ? _l : '',
            data.additionalFields ? data.additionalFields.join(';') : '',
            data.escapeNonNumericCharacters ? 'yes' : 'no',
            data.escapeLeadingZeros ? 'yes' : 'no',
            data.testEnabled ? 'yes' : 'no',
            (_m = data.testResponse) !== null && _m !== void 0 ? _m : '',
        ];
    });
}
export const JasBoardAdminPage = () => {
    return (React.createElement(ClassifierAdminPage, { entity: jasBoardEntityName, title: 'JAS Board', fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, formConfig: formConfig, csvFileHeader: csvFileHeader, mapCsvRowToData: mapCsvRowToData, mapDataToCsvRow: mapDataToCsvRow }));
};
const exampleResponseActive = {
    message: 'Test message active',
    success: true,
    licenseCheckResult: {
        status: 'ACTIVE',
        licenseNumber: '11111',
        expirationDate: '2050-01-01',
    },
};
const exampleResponseInactive = {
    message: 'Test message inactive',
    success: true,
    licenseCheckResult: {
        status: 'INACTIVE',
        licenseNumber: '11111',
    },
};
const exampleResponseExpired = {
    message: 'Test message expired',
    success: true,
    licenseCheckResult: {
        status: 'EXPIRED',
        licenseNumber: '11111',
        expirationDate: '2000-01-01',
    },
};
const exampleOigMatchResponse = {
    success: true,
    oigLicenseCheckResult: {
        status: 'MATCH',
        // TODO: change to dateOfBirthUsed after PLAT-1350 resolved
        dobUsed: false,
        records: [
            {
                lastName: 'ABRAHAM',
                firstName: 'JOSEPH',
                middleName: 'MICHAEL ',
                businessName: '',
                general: 'PHYSICIAN ASSISTANT',
                specialty: '',
                upin: '',
                npi: '0000000000',
                dateOfBirth: '19630224',
                address: '3731 BRENTWOOD AVE',
                city: 'EL PASO',
                state: 'TX',
                zip: '79902',
                exclusionType: '1128a1',
                exclusionDate: '19990920',
                reinstateDate: '00000000',
                waiverDate: '00000000',
                waiverState: '',
            },
            {
                lastName: 'ABRAHAM',
                firstName: 'JOSEPH',
                middleName: ' ',
                businessName: '',
                general: 'INDIVIDUAL (UNAFFILI',
                specialty: 'RECIPT/BENEFICIARY',
                upin: '',
                npi: '0000000000',
                dateOfBirth: '19630214',
                address: 'P O BOX 626',
                city: 'LOREAUVILLE',
                state: 'LA',
                zip: '70552',
                exclusionType: '1128a1',
                exclusionDate: '20191219',
                reinstateDate: '00000000',
                waiverDate: '00000000',
                waiverState: '',
            },
        ],
    },
};
const exampleOigNoMatchResponse = {
    success: false,
    oigLicenseCheckResult: {
        status: 'NO MATCH',
        // TODO: change to dateOfBirthUsed after PLAT-1350 resolved
        dobUsed: false,
    },
};
